import {
  doc,
  getDoc,
  updateDoc,
  collection,
  query,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import { useState, useEffect } from "react";
import { BatchQuicktalesRef, db, storage } from "../../../firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";

export const getSingleBatchQuickTale = async (id) => {
  try {
    return await getDoc(doc(db, "batchQuicktales", id));
  } catch (error) {
    console.log("error getting batch quicktale:", error.message);
  }
};

export const getSingleUser = async (userId) => {
  try {
    return await getDoc(doc(db, "users", userId));
  } catch (error) {
    // console.log("error getting user:", error.message);
  }
};

export const updateBatchQuickTale = async (qtId, quicktale) => {
  const batchQuicktaleDocRef = doc(db, "batchQuicktales", qtId);
  return await updateDoc(batchQuicktaleDocRef, quicktale);
};

export const uploadQuickTaleImageToStorage = async (file) => {
  const newFilename = uuidv4();
  const storageRef = ref(storage, `quicktales/images/${newFilename}`);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
};

export const uploadQuickTaleAudioToStorage = async (file) => {
  const newFilename = uuidv4();
  const storageRef = ref(storage, `quicktales/audio/${newFilename}`);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
};

export const uploadProcessedAudioToStorage = async (file) => {
  const newFilename = uuidv4();
  const storageRef = ref(storage, `processed-audio/quicktales/${newFilename}`);
  await uploadBytes(storageRef, file);
  return await getDownloadURL(storageRef);
};

/**
 * Real-time listener hook for shareActivity subcollection.
 * Works for both batchQuicktales and quicktales collections.
 * Returns events sorted by createdAt descending (most recent first).
 */
export const useShareActivityEvents = (quicktaleId, collectionName = "batchQuicktales") => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!quicktaleId) {
      setEvents([]);
      setLoading(false);
      return;
    }

    const shareActivityRef = collection(
      db,
      collectionName,
      quicktaleId,
      "shareActivity"
    );
    const q = query(shareActivityRef, orderBy("createdAt", "desc"));

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const data = snapshot.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        }));
        setEvents(data);
        setLoading(false);
      },
      (error) => {
        console.error("Error listening to shareActivity:", error);
        setEvents([]);
        setLoading(false);
      }
    );

    return unsubscribe;
  }, [quicktaleId, collectionName]);

  return { events, loading };
};
